import { Landmark, HeartPulse, Store, ShoppingCart, Clapperboard, Users2, CalendarDays, GraduationCap, Briefcase, Building2, Truck, Cpu, Cloud } from "lucide-react";
import { SectionHeading, FadeUp } from "./Reveal";

const INDUSTRIES = [
  { label: "Financial Services", Icon: Landmark },
  { label: "Healthcare", Icon: HeartPulse },
  { label: "Retail", Icon: Store },
  { label: "E-commerce", Icon: ShoppingCart },
  { label: "Media", Icon: Clapperboard },
  { label: "Associations", Icon: Users2 },
  { label: "Events", Icon: CalendarDays },
  { label: "Education", Icon: GraduationCap },
  { label: "Professional Services", Icon: Briefcase },
  { label: "Real Estate", Icon: Building2 },
  { label: "Logistics", Icon: Truck },
  { label: "Technology", Icon: Cpu },
  { label: "SaaS", Icon: Cloud },
];

export const Industries = () => (
  <section id="industries" data-testid="industries-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <SectionHeading
        testId="industries"
        overline="Industries"
        title={<>Intelligence <span className="jx-gradient-text">across industries.</span></>}
      />
      <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {INDUSTRIES.map((ind, i) => (
          <FadeUp key={ind.label} delay={i * 0.04} className={i === INDUSTRIES.length - 1 ? "col-span-2 sm:col-span-1" : ""}>
            <div
              data-testid={`industry-card-${i}`}
              className="group h-full rounded-2xl bg-white border border-jx-ink/8 px-5 py-6 flex items-center gap-4 hover:border-transparent hover:jx-gradient-bg transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_36px_rgba(78,33,120,0.2)]"
            >
              <ind.Icon className="w-5 h-5 text-jx-purple group-hover:text-white transition-colors duration-300 shrink-0" strokeWidth={1.6} />
              <span className="font-display font-semibold text-sm tracking-tight text-jx-ink group-hover:text-white transition-colors duration-300">{ind.label}</span>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
